<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import { appManager } from "../AppManager";

    const navigate = useNavigate();

    async function logout() {
        await appManager.logout();
        navigate("/", { replace: true });
    }
</script>

{#await logout()}
    <div />
{/await}
